// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAZtVjxcRQ2HFWAF-eGNdkpzF5qxBhel9M",
  authDomain: "susu-8bbc1.firebaseapp.com",
  databaseURL: "https://susu-8bbc1-default-rtdb.firebaseio.com",
  projectId: "susu-8bbc1",
  storageBucket: "susu-8bbc1.appspot.com",
  messagingSenderId: "241824082703",
  appId: "1:241824082703:web:af8fa6e6a304a9c7c22c7a",
  measurementId: "G-95PMRB2V9R",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
